import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const Header = ({ setShowBooking }) => {
  const navigate = useNavigate();
  
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <motion.header
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
      className="fixed top-0 left-0 right-0 z-50 glassmorphism"
      style={{
        background: 'rgba(255, 255, 255, 0.7)',
        backdropFilter: 'blur(16px)',
        WebkitBackdropFilter: 'blur(16px)',
        borderBottom: '1px solid rgba(255, 255, 255, 0.4)'
      }}
    >
      <div className="container mx-auto px-8 py-0">
        <div className="flex items-center justify-between">
          <img
            src="https://customer-assets.emergentagent.com/job_schedule-clean-3/artifacts/ps55wz7g_6CC27561-FF2C-4C06-AEF1-E32A8E83E69A.png"
            alt="Radius Cleaning Company"
            className="h-72 w-auto object-contain"
          />

          <nav className="hidden md:flex items-center gap-8">
            <button
              data-testid="nav-services"
              onClick={() => scrollToSection('services')}
              className="text-base font-medium hover:opacity-70 transition-opacity"
              style={{ color: '#475569' }}
            >
              Services
            </button>
            <button
              data-testid="nav-pricing"
              onClick={() => scrollToSection('pricing')}
              className="text-base font-medium hover:opacity-70 transition-opacity"
              style={{ color: '#475569' }}
            >
              Pricing
            </button>
            <button
              data-testid="nav-about"
              onClick={() => scrollToSection('about')}
              className="text-base font-medium hover:opacity-70 transition-opacity"
              style={{ color: '#475569' }}
            >
              About
            </button>
            <button
              data-testid="nav-contact"
              onClick={() => scrollToSection('contact')}
              className="text-base font-medium hover:opacity-70 transition-opacity"
              style={{ color: '#475569' }}
            >
              Contact
            </button>
            <button
              data-testid="nav-careers"
              onClick={() => navigate('/careers')}
              className="text-base font-medium hover:opacity-70 transition-opacity"
              style={{ color: '#475569' }}
            >
              Join Our Team
            </button>
          </nav>

          <button
            data-testid="header-book-now-btn"
            onClick={() => scrollToSection('pricing')}
            className="px-6 py-2 rounded-full font-medium hover:opacity-90 transition-opacity"
            style={{ background: '#0284C7', color: '#FFFFFF' }}
          >
            Book Now
          </button>
        </div>
      </div>
    </motion.header>
  );
};

export default Header;